// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"447":"912d5ddd","487":"ac5900e3","670":"dcb5437a"}[chunkId] + ".chunk.css";
};